import { dateShortOut } from 'Data/format'
import { date } from 'Data/validate'

export function formatOutDate(value) {
  let length = value.split('/')?.[2].length
  let formatted = dateShortOut(value)
  let isValid = date(formatted)
  return length !== 4 || !isValid ? value : formatted
}
